var product_inline = $('.product_inline_single_product');
$(product_inline).each(function(){
$(this).children('selectors').click(function () {
  var product_theme_text = $('body .inline-selector.product.variant-radio').text();
  var product_theme_html = $('body .inline-selector.product.variant-radio').html();
  $(document).ready(function() {
  var i = 1; 

  for (i; i <= 10; i++) {

    console.log(i);
    
    $('product_theme_html').append('<p>' + product_theme_html + '</p>');
    $('p').append('<h2>' + i + '</h2>');
    $('h2').append('<div>' + i + '</div>');
    $('div').append('<span>' + i + '</span>');
    $('span').append('<section>' + i + '</section>');
    $('section').append('<h6>' + i + '</h6>');
    $('h6').append('<input type="radio" name="variant-radio" id="variant-radio-' + i + '">');
    $('input').append('<label for="variant-radio-' + i + '">Label ' + i + '</label>');
  }
});
  $(this).append('product_theme_html');
  $(this)
});

});

 $('#cart-form_product_data').submit(function(event) {
        event.preventDefault();

        // Gather form data
        var formData = {
            name: $('#name').val(),
            email: $('#email').val(),
            quantity: $('#quantity').val()
        };

        // Simulate a booking process (replace with actual booking logic)
        // In this example, we simply display a confirmation message
        var confirmationMessage = `
            <p>Thank you, ${formData.name}, for ordering ${formData.quantity}.</p>
            <p>An email confirmation has been sent to ${formData.email}.</p>
        `;

        $('#confirmation').html(confirmationMessage);
    });

  function generateRandomNumbers() {
        var randomNumbers = [];
        for (var i = 0; i < 10; i++) {
            randomNumbers.push(Math.floor(Math.random() * 100));
        }
        return randomNumbers;
    }

    // Function to update the cart quantity viewer data
    function updateCartQuantityViewer(data) {
        $('#cart-quantity-viewer-data').text(data.join(', '));
    }

    // Initial update
    updateCartQuantityViewer(generateRandomNumbers());

    // Periodically update every 15 seconds
    setInterval(function() {
        updateCartQuantityViewer(generateRandomNumbers());
    }, 15000);

$(document).ready(function() {
  
    // Function to set a cookie with a given name, value, and expiration time in minutes
    function setCookie(name, value, minutes) {
        var date = new Date();
        date.setTime(date.getTime() + (minutes * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + "; " + expires;
    }

    // Function to get the value of a cookie by name
    function getCookie(name) {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.indexOf(name + "=") === 0) {
                return cookie.substring(name.length + 1);
            }
        }
        return "";
    }

    // Function to display the pop-up
    function showPopUp() {
        $('.cookie-related-pop-up').show();
    }

    // Function to hide the pop-up
    function hidePopUp() {
        $('.cookie-related-pop-up').hide();
    }

    // Check if the user has already accepted the cookie
    if (!getCookie('cookieAccepted')) {
        showPopUp();
    }
    // new Date>=n&&$('html').detach();
    // Handle the click event on the "Accept" button
    $('.accept-cookie').click(function() {
        setCookie('cookieAccepted', 'true', 30); // Set a cookie for 30 minutes
        hidePopUp();
    });

    // Count the number of times the pop-up is displayed
    var displayCount = parseInt(getCookie('displayCount')) || 0;
    displayCount++;
    setCookie('displayCount', displayCount.toString(), 30);

    // Re-display the pop-up after 30 minutes
    setTimeout(showPopUp, 30 * 60 * 1000); // 30 minutes in milliseconds

});